export class OrganizationSubscriptionUpdateRequest {
  constructor(public seatAdjustment: number, public maxAutoscaleSeats?: number) {}
}
